import(/* webpackMode: "eager" */ "/home/runner/work/travogue/travogue/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/travogue/travogue/src/app/components/PageWithFooter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/travogue/travogue/src/app/components/ui/BackButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/travogue/travogue/src/app/pages/blog/BlogArticleClient.jsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/travogue/travogue/src/styles/pages/blog/blog.module.scss");
